'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _UIDropdown = require('./UIDropdown');

var _UIDropdown2 = _interopRequireDefault(_UIDropdown);

var _UITypeahead = require('../typeahead/UITypeahead');

var _UITypeahead2 = _interopRequireDefault(_UITypeahead);

var _ButtonConstants = require('../button/ButtonConstants');

var _lazyEval = require('../utils/lazyEval');

var _lazyEval2 = _interopRequireDefault(_lazyEval);

var _createLazyPropType = require('../utils/propTypes/createLazyPropType');

var _createLazyPropType2 = _interopRequireDefault(_createLazyPropType);

var _OptionTypes = require('../types/OptionTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var UIDropdownSelect = _react2.default.createClass({
  displayName: 'UIDropdownSelect',

  propTypes: {
    buttonClassName: _react.PropTypes.string,
    buttonUse: _react.PropTypes.oneOf(Object.keys(_ButtonConstants.USE_CLASSES)).isRequired,
    onChange: _react.PropTypes.func,
    onSearchChange: _react.PropTypes.func,
    options: _react.PropTypes.arrayOf(_OptionTypes.OptionType).isRequired,
    placeholder: (0, _createLazyPropType2.default)(_react.PropTypes.string).isRequired,
    searchable: _react.PropTypes.bool.isRequired,
    value: _OptionTypes.SingleValueType
  },

  getDefaultProps: function getDefaultProps() {
    return {
      buttonClassName: 'p-x-2',
      buttonUse: 'transparent',
      placeholder: function placeholder() {
        return _I18n2.default.text('salesUI.UIDropdownSelect.placeholder');
      },
      searchable: false
    };
  },
  getButtonText: function getButtonText(_ref, _ref2) {
    var placeholder = _ref.placeholder;
    var selectedOption = _ref2.selectedOption;

    return selectedOption ? selectedOption.text : (0, _lazyEval2.default)(placeholder);
  },
  renderDropdownContent: function renderDropdownContent(_ref3) {
    var onChange = _ref3.onChange,
        options = _ref3.options,
        searchable = _ref3.searchable,
        onSearchChange = _ref3.onSearchChange;

    return _react2.default.createElement(_UITypeahead2.default, {
      resultsClassName: 'p-y-0' // the default padding is redundant in a UIDropdown
      , minimumSearchCount: searchable ? 0 : Infinity,
      onChange: onChange,
      onSearchChange: onSearchChange,
      options: options
    });
  },
  render: function render() {
    var _props = this.props,
        onChange = _props.onChange,
        options = _props.options,
        placeholder = _props.placeholder,
        searchable = _props.searchable,
        onSearchChange = _props.onSearchChange,
        value = _props.value,
        rest = _objectWithoutProperties(_props, ['onChange', 'options', 'placeholder', 'searchable', 'onSearchChange', 'value']);

    var selectedOption = void 0;
    options.forEach(function (option) {
      if (option.value === value && !selectedOption) {
        selectedOption = option;
      }
      if (option.options) {
        _devLogger2.default.warn({
          message: 'UIDropdownSelect: The given `options` include groups, which are not supported. ' + 'Use `UISelect` instead.',
          key: 'UIDropdownSelect-groups',
          url: 'https://git.hubteam.com/HubSpot/UIComponents/issues/6467'
        });
      }
    });

    return _react2.default.createElement(
      _UIDropdown2.default,
      _extends({}, rest, {
        buttonText: this.getButtonText({ placeholder: placeholder }, { selectedOption: selectedOption })
      }),
      this.renderDropdownContent({
        onChange: onChange,
        options: options,
        searchable: searchable,
        onSearchChange: onSearchChange
      })
    );
  }
});

exports.default = (0, _Controllable2.default)(UIDropdownSelect, ['open', 'value']);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/dropdown/UIDropdownSelect.js
// module id = 677
// module chunks = 3 4